import { type PropsWithChildren } from 'react';

import type { BehaviorTrackingProps } from '../../core/types/behavior-tracking-props.js';
import { DataTestId } from '../../core/types/data-props.js';
import { StylingProps } from '../../core/types/styling-props.js';
import type { SelectContentWidthOptionsType } from './types.js';

/**
 * Props for the SelectContent component
 * @public
 */
export type SelectContentProps = PropsWithChildren<unknown> &
  StylingProps &
  DataTestId &
  BehaviorTrackingProps & {
    /**
     * The current loading state of the Select.Content. If true, a loading icon is shown.
     * @defaultValue false
     */
    loading?: boolean;

    /**
     * The width of the Select.Content (overlay). By default it has a min-width of 96px and adjusts to the size of the trigger.
     * @defaultValue 'trigger'
     */
    width?: SelectContentWidthOptionsType;

    /**
     * Whether the selected options are reordered to the top of the options.
     * @defaultValue false
     */
    showSelectedOptionsFirst?: boolean;
  };

/**
 * `Select.Content` component
 * @public
 */
export function SelectContent(props: SelectContentProps): null {
  return null;
}
